import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/auth/local',
    method: 'post',
    data: {
      identifier: username,
      password: password
    }
  })
}

export function getInfo(fullname) {
  return request({
    url: '/users/me',
    method: 'get',
    params: {
      fullname: fullname,
      url: window.location.href
    }
  })
}

export function getService() {
  return request({
    url: '/services/personal/' + process.env.SERVICE_NAME,
    method: 'get'
  })
}

export function joinService(data) {
  return request({
    url: '/services/join/' + process.env.SERVICE_NAME,
    method: 'post',
    data
  })
}

export function changeUserData(data) {
  return request({
    url: '/services/modify/' + process.env.SERVICE_NAME,
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js